import React, {useContext, useEffect} from "react";
import { AuthContext, IntlContext } from "context";
import { TextField } from "components/Form/Field";
import Label from "ui/Form/Element/Label";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import {useForm, useFormState} from "react-final-form";

const OurServicesResumeInvoice: React.FC = () => {
    const intl = useContext(IntlContext);

    const { values } = useFormState();
    const { account } = useContext(AuthContext);
    const form = useForm();

    useEffect(() => {
        if (values?.activate_cesu_plus === '0' || !values.activate_cesu_plus && !values.cesu_plus_status) {
            form.change('total_amount', values?.initial_total_amount);
        } else {
            form.change('total_amount', values?.management_fees);
        }
    }, [values, form]);

    return (
        <React.Fragment>
            <h3 className="margin-bottom--3">{intl.formatMessage("our_services.form.label.booking_summary")}</h3>
            <div className="grid--1 grid--medium-1 grid--small-1">
                <Label className="field__label text-color--primary" style={{fontSize:"18px"}}>{intl.formatMessage("our_services.form.label.details_invoice")}</Label>
                <TextField
                    inputProps={{
                        name: "rate_hour",
                        autoComplete: "rate_hour",
                        placeholder: intl.formatMessage("our_services.form.label.details_invoice.rate_hour"),
                        disabled: true,
                    }}
                    labelProps={{
                        label: intl.formatMessage("our_services.form.label.details_invoice.rate_hour"),
                    }}
                    symbol=" €"
                />
                <TextField
                    inputProps={{
                        name: "management_fees",
                        autoComplete: "management_fees",
                        placeholder: intl.formatMessage("our_services.form.label.details_invoice.management_fees"),
                        disabled: true,
                    }}
                    labelProps={{
                        label: intl.formatMessage("our_services.form.label.details_invoice.management_fees"),
                    }}
                    symbol=" €"
                />
                {account?.resources?.client[0].company_id &&
                <TextField
                    inputProps={{
                        name: "supported_company",
                        autoComplete: "supported_company",
                        placeholder: intl.formatMessage("our_services.form.label.details_invoice.supported_company"),
                        disabled: true,
                    }}
                    labelProps={{
                        label: intl.formatMessage("our_services.form.label.details_invoice.supported_company"),
                    }}
                    symbol=" €"
                />
                }
                <TextField
                    inputProps={{
                        name: "total_amount",
                        autoComplete: "total_amount",
                        placeholder: intl.formatMessage('our_services.form.label.details_invoice.total_amount_to_pay'),
                        disabled: true,
                    }}
                    labelProps={{
                        label: intl.formatMessage('our_services.form.label.details_invoice.total_amount_to_pay'),
                    }}
                    symbol=" €"
                />
                {values.employer_contributions > 0 && values.employee_contributions_ef > 0 && (
                    <div className="grid--12 grid--medium-1 grid--small-1 margin-top--5">
                        <div className="grid__col--6 grid__col--small-12">
                            <Label className="field__label text-color--primary" style={{fontSize:"18px"}}>Détail URSSAF</Label>
                            <p className="comment">
                                Cotisations patronales : {(values.employer_contributions).toFixed(2)} €<br/>
                                Cotisations salariales : {(values.employee_contributions_ef).toFixed(2)} €<br/>
                                Total cotisations sociales : <strong>{(values.employer_contributions + values.employee_contributions_ef).toFixed(2)} €</strong>
                            </p>
                            <p className="comment margin-top--2">
                                Total provisoire prestation :
                                <span className="bold">&nbsp;
                                    {(values.rate_hour + values.employer_contributions + values.employee_contributions_ef + values.management_fees).toFixed(2)} €
                                </span>
                                <span className="btn-tooltip" style={{ marginLeft: "8px" }}>
                                    <span className="icon icon-info" style={{fontSize:"14px"}}></span>

                                    <span className="btn-tooltip__content">
                                        Total "salaire + cotisations sociales + commission"
                                    </span>
                                </span>
                            </p>
                            <p className="comment margin-top--2">
                                <p className="comment">
                                    Estimation du crédit d'impôt :&nbsp;
                                    <span className="bold">
                                        {((values.rate_hour + values.employer_contributions + values.employee_contributions_ef) / 2).toFixed(2)} €
                                    </span>
                                    <span className="btn-tooltip" style={{ marginLeft: "8px" }}>
                                        <span className="icon icon-info" style={{fontSize:"14px"}}></span>

                                        <span className="btn-tooltip__content">
                                            50% du total "salaire + cotisations sociales"
                                        </span>
                                    </span>
                                </p>
                            </p>
                        </div>
                        <div className="grid__col--6 grid__col--small-12">
                            <Label className="field__label text-color--primary" style={{fontSize:"18px"}}>En résumé :</Label>
                            <div style={{borderRadius: "8px", border: "2px solid #b2b2b2"}}>
                                <ul className="text-color--success-dark" style={{ listStyleType: "none", fontSize: "14px", margin:"0", padding: "8px"}}>
                                    <li>
                                        <Icon icon={{ prefix: "fas", iconName: "check" }} />&nbsp;
                                        Vous payez <strong>{values.total_amount} €</strong> maintenant
                                    </li>
                                    <li style={{ margin: "8px 0" }}>
                                        <Icon icon={{ prefix: "fas", iconName: "check" }} />&nbsp;&nbsp;
                                        L'URSSAF prélève automatiquement vos cotisations sociales : <strong>{(parseFloat(values.employer_contributions) + parseFloat(values.employee_contributions_ef)).toFixed(2)} €</strong>
                                    </li>
                                    {(values?.activate_cesu_plus && values?.activate_cesu_plus === '1' || values?.cesu_plus_status) && (
                                        <li style={{ margin: "8px 0" }}>
                                            <Icon icon={{ prefix: "fas", iconName: "check" }} />&nbsp;&nbsp;
                                            L'URSSAF prélève automatiquement le salaire du prestataire : <strong>{values.rate_hour} €</strong>
                                        </li>
                                    )}
                                    <li style={{ margin: "8px 0" }}>
                                        <Icon icon={{ prefix: "fas", iconName: "check" }} />&nbsp;&nbsp;
                                        Vous bénéficiez d'un crédit d'impôt de <strong>{((values.rate_hour + values.employer_contributions + values.employee_contributions_ef) / 2).toFixed(2)} €</strong>&nbsp;
                                        {values?.aici_status || values.activate_cesu_plus && values?.activate_cesu_plus === '1' ? (
                                            <u>immédiatement</u>
                                        ) : (
                                            <u>l'année suivante</u>
                                        )}
                                    </li>
                                    <li className="text-color--primary">
                                        Coût net final : <strong>{((values.rate_hour + values.employer_contributions + values.employee_contributions_ef + values.management_fees)- ((values.rate_hour + values.employer_contributions + values.employee_contributions_ef) / 2)).toFixed(2)} €</strong>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default OurServicesResumeInvoice;
